<template>
  <div class="animated fadeIn upload-debitur">
    <b-card v-if="!showUploadFrm">
      <div slot="header">
        Hasil Import Data Debitur
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-card no-body>
        <template v-slot:header v-if="(filterShow=='Hide')">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="rekonsil">Rekon Status</b-form-checkbox>
                  <b-form-checkbox value="uraian1">Description Sub Modul</b-form-checkbox>
                  <b-form-checkbox value="uraian2">Description GL</b-form-checkbox>
                  <b-form-checkbox value="nilai1">Value Sub Modul</b-form-checkbox>
                  <b-form-checkbox value="nilai2">Value GL</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0 text-nowrap"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(tanggal1)="data">
            <span v-if="(data.item.tanggal1)">{{ data.item.tanggal1 | moment("DD-MMM-YYYY") }}</span>
          </template>
          <template v-slot:cell(tanggal2)="data">
            <span v-if="(data.item.tanggal2)">{{ data.item.tanggal2 | moment("DD-MMM-YYYY") }}</span>
          </template>
          <template
            v-slot:cell(nilaiori)="data"
          >{{ data.item.matauang }} &nbsp; {{ data.item.nilaiori | numFormat }}</template>
          <template v-slot:cell(nilai1)="data">{{ data.item.nilai1 | numFormat }}</template>
          <template v-slot:cell(nilai2)="data">{{ data.item.nilai2 | numFormat }}</template>
          <template v-slot:cell(valas_in)="data">{{ data.item.valas_in | numFormat }}</template>
          <template v-slot:cell(valas_out)="data">{{ data.item.valas_out | numFormat }}</template>
          <template v-slot:cell(sakhirOri)="data">{{ data.item.sakhirOri | numFormat }}</template>
        </b-table>
        <b-row class="mt-2">
          <b-col lg="8">
            <b-row>
              <b-col cols="2">
                <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox>
              </b-col>
              <b-col cols="10">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
                    <span class="mr-1">limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="4">
            <b-row align-h="right">
              <b-col md="5">
                <b-form-group label="Total Sisa Pokok">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalModul"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group label="Total Sisa Bunga">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalGl"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-row align-h="center" v-else>
      <b-col md="12">
        <b-card>
          <div slot="header">
            Import Data Debitur
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>

          <b-card class="ColsDefine">
            <strong>Difinisi nama Kolom Excel untuk setiap Fileld pada data Debitur<br><br></strong>
            <b-row>
              <b-col lg="4">
                <label>DATA DEBITUR</label>
                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Nama (sesuai KTP/ Passpor*)</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.pemohon_name"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Tempat lahir</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.tmptlahir"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Tanggal lahir</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.tgllahir"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Jenis Kelamin</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.jnskelamin"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Nomor KTP/ Paspor*</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.nomoridentitas" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>NPWP Pribadi</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.nonpwp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Kewarganegaraan</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kewarganegaraan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Status Perkawinan</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.statusperkawinan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Jumlah Tanggungan</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.jmltanggungan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Pendidikan Terakhir</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.pendidikanterakhir" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                
                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Alamat Sesuai KTP/ Passpor</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.alamatktp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Kelurahan</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kelurahanktp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Kecamatan</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kecamatanktp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Kota</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kotaktp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Propinsi</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.provinsiktp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Kodepos</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kodeposktp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Status Rumah Tinggal</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.statusrmhtinggal" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Lama Tinggal (Tahun)</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.lamatinggalthn" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Lama Tinggal (Bulan)</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.lamatinggalbln" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Nomor Telepon Rumah</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.notlprumah" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Nomor Telepon Selular</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.nohandphone" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>E-mail</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.email" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend style="width:200px">
                    <label>Nama Gadis Ibu Kandung</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.namaibu" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>

              </b-col>
              
              <b-col lg="4">
                <label>DATA KELUARGA TERDEKAT</label>
              </b-col>

              <b-col lg="4">
                <label>DATA PEKERJAAN DEBITUR</label>
                
              </b-col>
              
            </b-row>
          </b-card>
          <b-input-group>
            <b-input-group-prepend>
              <label>Choose *.XLSX file</label>
            </b-input-group-prepend>
            <b-form-file
              v-model="fileXlsx"
              :state="Boolean(fileXlsx)"
              placeholder="Choose a XLSX file..."
              drop-placeholder="Drop XLSX file here..."
            ></b-form-file>
          </b-input-group>
          <b-row no-gutters>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Nama SHEET</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmUpload.sheetName" :state="!$v.frmUpload.sheetName.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-append>
                  <label class="input-group-text ml-1">Data mulai baris ke-</label>
                </b-input-group-append>
                <b-form-input
                  v-model="frmUpload.startRow"
                  type="number"
                  :state="!$v.frmUpload.startRow.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <div slot="footer" class="text-center">
            <b-button variant="primary" @click="importdata()">Import</b-button>
            <b-button variant="danger" @click="close()">Cancel</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.upload-debitur {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import moment from "moment";
// import arreport from "../../apis/arreport";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmUpload: {
      sheetName: { required },
      startRow: { required },
      CustCode: { required },
      CustName: { required },
      uraian1: { required },
      invoiceno: { required },
      invdate: { required },
      artype: { required },
      matauang: { required },
      ttlgross: { required },
      ttlnetto: { required },
      ttlvat: { required },
      ttlamtdue: { required }
    },
    model: {
      tgl1: { required },
      tgl2: { required }
    }
  },
  data() {
    return {
      showUploadFrm: true,
      fileXlsx: null,
      frmUpload: {
        sheetName: "AR_LIST",
        startRow: 8,
        invoiceno: "A",
        invdate: "B",
        CustCode: "C",
        CustName: "D",
        uraian1: "E",
        uraian2: "F",
        matauang: "G",
        ttlgross: "H",
        ttldiskon: "I",
        ttlnetto: "J",
        ttlvat: "K",
        ttlamtdue: "L"
      },
      kolomXls: [
        "",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "AA",
        "AB",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AH",
        "AI",
        "AJ",
        "AK",
        "AL",
        "AM",
        "AN",
        "AO",
        "AP",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AV",
        "AW",
        "AX",
        "AY",
        "AZ"
      ],

      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      model: { account: "", tgl1: "", tgl2: "" },
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines: [],
      subtotal: {},
      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "nomor1",
            label: "No.Kontrak",
            sortable: true
          },
          {
            key: "tanggal1",
            label: "tgl. Kontrak",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "uraian1",
            label: "Nama Debitur"
          },
          {
            key: "alamat",
            label: "Alamat Debitur",
            sortable: true
          },
          {
            key: "principal",
            label: "Pokok Pinjaman",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "tenor",
            label: "Jk.Waktu",
            thStyle: "width:60px",
            thClass: "text-center text-success",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "interstrate",
            label: "Bunga(%)",
            thStyle: "width:80px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "interest",
            label: "Total Bunga",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "installment_amount",
            label: "Angsuran per bulan",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "paymentotal",
            label: "Total Pembayaran",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "principal_outstand",
            label: "Sisa Pokok",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "interst_outstand",
            label: "Sisa Bunga",
            thStyle: "width:140px",
            thClass: "text-right ",
            tdClass: "text-right"
          },
          {
            key: "lastinstallno",
            label: "Angsuran ke-",
            thStyle: "width:140px",
            thClass: "text-right text-warning",
            tdClass: "text-right"
          }
        ]
      },
      filter: null,
      filterOn: []
    };
  },
  components: { Loading, myNumber },
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    account() {
      return this.model.account;
    }
  },
  watch: {
    account: function(newval) {
      const obj = this.accounts.find(d => d.value === newval);
      this.model.namaacc = obj.text || "";
      this.model.kodeacc = obj.kodeacc;
      // console.log(`${this.model.account} | ${this.model.namaacc}`);
    }
  },
  // created: async function(){
  //     const accList = await arreport.postgroup();
  //     this.accounts = accList.reduce((newArr,item) =>{
  //           newArr.push(item);
  //           return newArr;
  //       },[{ value: '', text: '--- ALL ---'}]);
  //       const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
  //       this.model.tgl1=this.$store.state.user.tglaktif;
  //       this.model.tgl2=tgl2.format('YYYY-MM-DD');
  // },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    importdata() {
      this.showUploadFrm = false;
    },
    getData: async function(ctx) {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        const result = await arreport.rekondb(this.model);
        this.rptLines = result[0];
        // console.log('this.rptLines :', this.rptLines.filter(r => r.rekonsil==0));
        this.subtotal = result[1][0];
        this.subtotal.selisih =
          this.subtotal.totalModul - this.subtotal.totalGl;
        this.tblLcy.total = this.rptLines.length;
        this.isLoading = false;
      }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await arreport.rekondbexport(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
    }
  }
};
</script>
